import { render, staticRenderFns } from "./appStoreBtns.vue?vue&type=template&id=0c22ad41&scoped=true&"
var script = {}
import style0 from "./appStoreBtns.vue?vue&type=style&index=0&id=0c22ad41&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22ad41",
  null
  
)

export default component.exports